 import httpService from '../_utils/http-service';

export const connectToBackEnd = (callback) => {

    return function (dispatch) {

        httpService.get('/test')
            .then((res) => {
                callback({ connected: true })
            })
            .catch((err) => {
                callback({ connected: false });
            });
    }
}

